(function () {
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var parcelRequire = $parcel$global["parcelRequirefdb2"];
parcelRequire.register("7Sqka", function(module, exports) {

var $lzkzF = parcelRequire("lzkzF");

var $2UsKn = parcelRequire("2UsKn");
window.openTeamModal = (0, $2UsKn.openTeamModal);
var teamModals = document.getElementsByClassName("team-modal");
if (!teamModals) return;
Array.from(teamModals).forEach(function(teamModalEl) {
    var modalSlider = teamModalEl.querySelector(".team-modal__slider");
    // Initialise and mount our slider
    var splideOptions = {
        useIndex: true,
        type: "fade",
        rewind: true,
        speed: 500,
        pagination: false,
        easing: "cubic-bezier(0.25, 1, 0.5, 1)",
        perPage: 1
    };
    var teamModalSlider = new (0, $lzkzF.default)(modalSlider, splideOptions);
    // Mount the slider
    teamModalSlider.mount();
    // Store the splide instance against the modal so we can easily hook in
    teamModalEl.splideInstance = teamModalSlider;
});

});

})();
//# sourceMappingURL=team.5aa203ff.js.map
